import { useMemo, useEffect } from "react";
import useFormAction from "@insightfulscience/smart-react/hooks/useFormAction";
import searchPlasmid from "../../providers/searchPlasmid";
import { debounce } from "../../utils/async-effects";

export default function useSearchPlasmid(input) {
	const [action, { result }] = useFormAction(searchPlasmid);

	const runSearchPlasmid = useMemo(
		() => debounce(action, 500), //
		[action],
	);

	useEffect(() => {
		if (input.length > 0) runSearchPlasmid(input);
	}, [input]);

	const { query = "", plasmid = [] } = result ?? {};

	const isLoading = input.length > 0 && input !== query;

	const total = plasmid.reduce((prev, current) => {
		return prev + current.sequences.length;
	}, 0);
	const isAnyMatch = total > 0;

	return { isLoading, isAnyMatch, plasmid, total };
}
